import { DocumentClassKey } from '../../document-classes/document-classes';
import { CtPage } from '../../model/ct-batch-model';

export interface CurrentPage extends CtPage {
  previewIndex: number;
}

export type SelectInitialPageBehaviour = 'first' | 'none';

export function fixDocumentClass(documentClass: DocumentClassKey) {
  if ((documentClass as string) === 'AUU' || (documentClass as string) === 'AU BESCHEINIGUNG') {
    return '25_Q3_AU_BESCHEINIGUNG';
  }
  if ((documentClass as string) === 'BEIHILFEBESCHEID') {
    return '25_Q3_BEIHILFEBESCHEID';
  }
  if ((documentClass as string) === 'BERICHT') {
    return '25_Q3_KRANKENHAUS_BERICHT';
  }
  if ((documentClass as string) === '301ER_DATEN' || (documentClass as string) === '301ER DATEN') {
    return '25_Q3_301ER_DATEN';
  }
  if ((documentClass as string) === 'FORDERUNGSAUFSTELLUNG') {
    return '25_Q3_FORDERUNGSAUFSTELLUNG';
  }
  if ((documentClass as string) === 'RECHNUNG') {
    return '25_Q3_RECHNUNG';
  }
  if ((documentClass as string) === 'SCHADENANZEIGE') {
    return '25_Q3_SCHADENANZEIGE';
  }
  if ((documentClass as string) === 'SONSTIGES') {
    return '25_Q3_SONSTIGES';
  }
  if ((documentClass as string) === 'VERORDNUNG') {
    return '25_Q3_VERORDNUNG';
  }
  if ((documentClass as string) === 'ANSCHREIBEN') {
    return '25_Q3_FORDERUNGSSCHREIBEN';
  }
  return documentClass;
}
